/**
* DevExpress HTML/JS Reporting (designer\controls\properties\watermark.js)
* Version:  23.1.4
* Build date: Jul 18, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { SerializableModel } from '@devexpress/analytics-core/analytics-elements';
import * as $ from 'jquery';
import { ImageSource } from '../../../common/imageSource';
import { watermarkSerializationsInfo } from '../metadata/properties/watermark';
export class WatermarkModel extends SerializableModel {
    constructor(model, serializer) {
        super(model || {}, serializer, watermarkSerializationsInfo);
        this.rtl = $.noop;
        if (!this.imageSource() && model && model['@Image']) {
            this.imageSource(new ImageSource('img', model['@Image']));
            delete this['_model']['@Image'];
        }
    }
    shouldDrawWatermarkImage() {
        return this.imageSource() && this.imageSource().sourceType !== 'svg';
    }
}
